import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { addRule } from '../../actioncreators/actioncreators'

const { Component } = React

const Button = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  min-width: 286px;
  max-width: 286px;
  min-height: 152px;
  max-height: 152px;
  margin-left: 2px;
  margin-bottom: 20px;

  background: #ffffff00;
  border: none;
  outline: none;

  &:focus {
    outline: none;
  }
`

const I = styled.i`
-webkit-transition: -webkit-transform .1s ease-in-out;
transition: transform .1s ease-in-out;
margin-left: -120px;
color: #0C8CE6;

&:hover {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
`

class AddRuleButton extends Component {
  render () {
    return (
      <Button onClick={this.props.addRule}>
        <I className='fas fa-plus fa-5x' title='Add rule' />
      </Button>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    addRule: () => dispatch(addRule(ownProps.ruleRowIndex))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddRuleButton)
